import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { CSSObject } from '@tq/ui-components/dist/styled-system';

const dataTableStyle: CSSObject = {
  '.tqc-th': { backgroundColor: COLOURS.blue[150] },
  '.tqc-tbody': { borderCollapse: 'unset' },
  '.tqc-tbody .tqc-tr': {
    outlineStyle: 'none',
    border: `1px solid ${COLOURS.gray[400]}`,
    borderTop: 'none',
  },
  borderRadius: 0,
};

export default dataTableStyle;
